import React from "react";

const WORDS = [
  "TSUNAMI",
  "GODLY",
  "AMERICAN ARTIST",
  "MAJESTIC",
  "TSUNAMI",
  "UNDERTOW",
  "CASSIUS GRATE",
  "TSUNAMI",
  "SALTWATER CROWN",
  "TSUNAMI",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="marquee" className="relative border-y border-white/5 bg-ink-900/40 py-6 overflow-hidden mask-fade-x">
      <div className="flex gap-12 whitespace-nowrap animate-marquee w-max">
        {row.map((w, i) => (
          <span
            key={i}
            className={`font-display font-black text-3xl md:text-5xl tracking-tighter uppercase ${
              i % 2 === 0 ? "text-outline" : "text-shimmer-gold"
            }`}
          >
            {w}
            <span className="mx-6 text-cyan-neon">~</span>
          </span>
        ))}
      </div>
    </div>
  );
};
